var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center  hover:text-primary"},[_vm._v("\n  "+_vm._s(_vm._f("moment")(_vm.params.value,"MMM D YYYY, h:mm a"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }